export const GET_PROJECTS = 'GET_PROJECTS'
export const GET_PROJECTS_BY_CATEGORY = 'GET_PROJECTS_BY_CATEGORY'
export const ADD_PROJECT = 'ADD_PROJECT'
export const UPDATE_PROJECT = 'UPDATE_PROJECT'
export const DELETE_PROJECT = 'DELETE_PROJECT'
export const PHOTO_UPLOAD = 'PHOTO_UPLOAD'
export const PROJECT_ERROR = 'PROJECT_ERROR'

export const GET_INTRO = 'GET_INTRO'
export const GET_SOCIAL = 'GET_SOCIAL'
export const GET_EDUCATION = 'GET_EDUCATION'
export const GET_SKILLS = 'GET_SKILLS'
export const GET_JOURNEY = 'GET_JOURNEY'
export const GET_PROGRESS_BARS = 'GET_PROGRESS_BARS'
export const INFO_ERROR = 'INFO_ERROR'